import de from '../config/intl/de.json';
import en from '../config/intl/en.json';
import fr from '../config/intl/fr.json';

/**
 * Flattens nested message objects into dot-notation keys for react-intl
 * e.g., { foo: { bar: 'baz' } } → { 'foo.bar': 'baz' }
 */
export const flattenMessages = (obj: Record<string, unknown>, prefix = ''): Record<string, string> =>
  Object.keys(obj).reduce((acc: Record<string, string>, k) => {
    const pre = prefix.length ? prefix + '.' : '';
    if (typeof obj[k] === 'object' && obj[k] !== null) {
      Object.assign(acc, flattenMessages(obj[k] as Record<string, unknown>, pre + k));
    } else {
      acc[pre + k] = String(obj[k]);
    }
    return acc;
  }, {});

/**
 * Pre-flattened messages for all supported locales.
 * Use this instead of manually flattening in each component.
 */
export const allMessages = {
  de: flattenMessages(de),
  en: flattenMessages(en),
  fr: flattenMessages(fr),
};
